import { FC } from 'react'

import styles from './Description.module.scss'

export const Description: FC = ({ children }) => <p className={styles.root}>{children}</p>
